import _extends from "@babel/runtime/helpers/extends";
import _get from 'lodash/get';

/**
 * Find inventory and owner data using inventoryId
 */
export default (function (state, inventoryId, isDealer) {
  if (state === void 0) {
    state = {};
  }
  var inventory = _get(state, "inventory." + inventoryId) || _get(state, "preorder." + inventoryId) || {};
  var owner = {};
  if (_get(inventory, 'owner.id')) {
    // if inventory.owner is already an object
    owner = inventory.owner;
  } else if (_get(state, "owners." + inventory.owner)) {
    // if inventory.owner is owner id
    owner = _get(state, "owners." + inventory.owner);
  } else if (isDealer) {
    owner = _get(state, "owners." + inventoryId, {});
  } else if (_get(inventory, 'ownerId')) {
    // sometimes the listing only has ownerId -- and owner data would be a separate object
    owner = {
      id: _get(inventory, 'ownerId')
    };
  }
  return _extends({}, inventory, {
    owner: _extends({}, owner)
  });
});